import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/movimientocaproveedores';
import moment from 'moment';
import Select from 'react-select';

import {api} from '../../actions/_request';

import ModalTablas from '../../components/catalogos/modal_tablas';
import Proveedor from "../proveedores/Modal";


const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };



class EmbarqueModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            compra: {
                id:0,
                proveedor_id:0,
                movimiento_id:0,
                factura_id:0,
                cantidad:0,
                impuestos:0,
                total:0,
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1
                             
            },
            factura:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',

            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',

        
           
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
       


        

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.toggle_modal_registro= this.toggle_modal_registro.bind(this); 
                 
    }

     modal_open(){
       document.getElementById('body').className = "modal-open ";
    }
    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
        // console.log('se agrega un modal-open')
         setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
        console.log('nada')
        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }
    handleClose (event) {
        console.log('evento--->',event)
         
        let {compra} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla="";
        let bandera_proveedor=true;

        
         switch (name) {
            case "factura_codigo":                  
                  campo = "factura_id";
                  tabla="/busqueda_compra/"+compra.proveedor_id;
                  if(parseInt(compra.proveedor_id)==0)
                    bandera_proveedor=false;

                  break;
            case "proveedor_codigo":                                  
                  campo = "proveedor_id";
                  tabla="/proveedor";                   
                  break;
            case "movimiento_codigo":                 
                  campo = "movimiento_id";
                  tabla="/busqueda_movimiento";
                  break;      
        }
        let self =this;
        if(value!=""&&bandera_proveedor){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                         self.retorno(retorno,campo,vaciar,value);                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }                            
                   
                }

            });
        }else{
           if(bandera_proveedor==false){
            swal("Oops..", "Selecciona un proveedor");

          }
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let saldo="$0.00";
        let credito="$0.00";
        let bandera=false;
        console.log('renglon---->',objeto);
        let {compra} = this.state;
        let self =this;
        
         if(vacio==1){
          console.log('vaciar')
          codigo=valor;
          descripcion="";
          compra[campo] =0;
         }

         console.log('descripcion--->',descripcion);

         switch (campo) {
            case "proveedor_id":
                if(vacio==1){
                  console.log('vaciar')
                  compra[campo] =0;
                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:valor,
                        proveedor_descripcion:'',
                        saldo_proveedor:'$0.00',
                        modal:false,         
                    }) 
                 }else{
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:objeto.value?objeto.value:objeto.id,
                        proveedor_descripcion:objeto.label?objeto.label:objeto.nombre,
                        saldo_proveedor:objeto.saldo,
                        modal:false,         
                    }) 

                 }  
                  break;
            case "factura_id":
                  if(vacio==1){
                    console.log('vaciar')
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.cantidad = '0.00';
                      compra.impuestos = '0.00';
                      compra.total = '0.00';
                     self.setState({
                        factura:[],
                        compra : compra,           
                        factura_codigo:valor,
                        factura_descripcion:'',
                        saldo_documento:'$0.00',
                        saldo_original:'$0.00',
                        subtotal_documento:'$0.00',
                        impuesto_documento:'$0.00',
                        modal:false,         
                    }) 
                   }else{
                     codigo=objeto.factura;
                      descripcion=objeto.concepto;
                      campo_codigo="factura_codigo";
                      campo_descripcion="factura_descripcion"; 
                      compra[campo] = objeto.value?objeto.value:objeto.id;
                      compra.cantidad = objeto.subtotal_numero;
                      compra.impuestos = objeto.impuesto_numero;
                      compra.total = objeto.saldo_numero;
                       self.setState({
                        factura:objeto,
                        compra : compra,           
                        [campo_codigo]:codigo,
                        [campo_descripcion]:descripcion,
                        saldo_documento:objeto.saldo,
                        saldo_original:objeto.total,
                        subtotal_documento:objeto.subtotal,
                        impuesto_documento:objeto.impuesto,
                        modal:false,         
                  })
                   }
                 
                  break;
            case "movimiento_id":
                  if(vacio==1){
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.tipo =0;
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:valor,
                        movimiento_descripcion:'',
                        naturaleza:'',
                        modal:false,         
                    }) 
                   }  else{
                    compra[campo] = objeto.value?objeto.value:objeto.id;  
                    compra.tipo = objeto.tipo;  
                    compra.concepto=objeto.tipo_nombre;                             
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:objeto.codigo,
                        movimiento_descripcion:objeto.label,
                        naturaleza:objeto.tipo_nombre,
                        modal:false,         
                    }) 

                   }
                  
                  break;    
        }
        
    }
    toggle_modal(index=0,catalogo="",campo=""){
    if(campo=='factura_id'&&parseInt(this.state.compra.proveedor_id)==0){
        swal("Oops..", "Selecciona un proveedor");

    }else{
        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }  

        
    }   

    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            compra: {
                ...this.state.compra,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {
         
        let prospectoid = this.props.prospectoid;
        let self = this;

         api().get('/sat/formas_pago/2')
      .then(function(response)
      {
        if(response.status === 200)
        {
          self.setState({
            formas : response.data
          });
        }
      });
              
        if(prospectoid > 0 && prospectoid != self.state.compra.id)
        {

            api().get(`movimientocap/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        compra: response.data.movimientoca,
                        action: 'update',
                        factura:response.data.factura,
                        proveedor_codigo:response.data.proveedor.codigo,
                        proveedor_descripcion:response.data.proveedor.nombre,
                        saldo_proveedor:response.data.proveedor.saldo,
                        factura_codigo:response.data.factura.factura,
                        factura_descripcion:response.data.factura.concepto,
                        movimiento_codigo:response.data.movimiento.codigo,
                        movimiento_descripcion:response.data.movimiento.nombre,
                        naturaleza:response.data.movimiento.naturaleza,
                        subtotal_documento:response.data.factura.subtotal,
                        impuesto_documento:response.data.factura.impuesto,
                        saldo_documento:response.data.factura.saldo,
                        saldo_original:response.data.factura.total,
                    });

                }

            });
        }
        else if(prospectoid == null && self.state.compra.id)
        {   
            console.log('Reset Modal');
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
           compra: {
                  id:0,
                  proveedor_id:0,
                  movimiento_id:0,
                  factura_id:0,
                  cantidad:0,
                  impuestos:0,
                  total:0,
                  fecha: moment().format('Y-MM-DD'),
                  concepto:'',
                  referencia:'',
                  tipo:1
                             
            },
            factura:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',
        });
        
    }
    handleInputChange(event) {
        let {compra,factura} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        compra[name] = value;
        if(name=='total')
        {
          let factor=factura.factor_impuesto;
          let uno= parseFloat( compra.total)/(factor+100);
          

          compra.impuestos=this.trunc(uno*factor,2);
          compra.cantidad=this.trunc(uno*100,2);

          console.log("factor---->", factor )
          console.log("impuestos---->",parseFloat( compra.impuestos ))
          console.log("cantidad---->",parseFloat( compra.cantidad ))
          console.log("total---->",parseFloat( compra.total ))
        }
     
        this.setState({
            compra : compra
        });
    }

      trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}
   

   objeto_mayusculas(objeto){
      for (var key in objeto) {
        if (objeto.hasOwnProperty(key)) {                    
          objeto[key] = String(objeto[key]).toUpperCase() ;
          if( String(objeto[key]).toUpperCase()==='NULL')
            objeto[key] ='';
        }
      }
      return objeto;
    }
   
   

   handleSubmit(evt){
        evt.preventDefault();
        let {compra,factura} = this.state;
        let action=this.state.action;
        
        let save=true;
        let mensaje=true;
        let dato="";
        let self = this;        
        
            let check = ['referencia','concepto','fecha'];

            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }
            check = [
            'proveedor_id',
            'movimiento_id',
            'factura_id',
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(parseInt( value) == 0) {
                save = false;
                break;
            }
                
            }

            check = [
            'total',
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(isNaN(parseInt( value))) {
                save = false;
                break;
            }
                
            }
            if(save && parseInt(compra.tipo)==1 ){
              console.log("compra--->",parseFloat(compra.cantidad));
              console.log('factura--->',parseFloat(factura.subtotal_numero));
              if( parseFloat(compra.cantidad)>parseFloat(factura.subtotal_numero))
              {
                dato= "Cantidad es mayor al del Documento a afectar";
                save=false;
              }
              if(parseFloat(compra.impuestos)>parseFloat(factura.impuesto_numero))
              {
                dato= "Impuesto es mayor al del Documento a afectar";
                save=false;
              }
               if(parseFloat(compra.total)>parseFloat(factura.saldo_numero))
              {
                dato= "total es mayor al del Documento a afectar";
                save=false;
              }
              if(parseFloat(compra.total)<=0)
              {
                dato= "total no puede ir en 0";
                save=false;
              }
              if(parseFloat(compra.cantidad)<=0)
              {
                dato= "cantidad no puede ir en 0";
                save=false;
              }
          }

        compra=this.objeto_mayusculas(compra);
        

        if(save   ){

          api().post(`/movimientocap_validar`, compra)
            .then(function(response)
            {
                let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];

                if(validacion||(parseInt(encontrado.id)===parseInt(compra.id) )){
                        self.props[action](compra, (data) => {

                          self.props.alerta({
                          mensaje:"C / A Proveedor Guardado correctamente!",
                          tipo:"success",
                          creacion:moment().format('Y-MM-DD H:m:s'),
                          });
                          self.props.toggle();
                          self.resetModal();
                  
                });

                }else{
                    swal("Oops..", "La Referencia ya existe");
                }
            });
        
                    

               
            
        }else{
          
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }
    }

    render()
    {

        let {compra,action,factura}=this.state;
         let editar=true;
         if(action=='update')
          editar=false;

        console.log('factura--->',factura);
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Nota
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                         <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-3"> 
                                        <div className="form-group">
                                            <label className="d-block">Movimiento:</label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="movimiento_codigo"
                                            value={this.state.movimiento_codigo}
                                            onChange={ this.ChangeCode}
                                            onBlur={this.handleClose}
                                            className="input_button"
                                            disabled={!editar}
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(28,"Tipos de Movimiento","movimiento_id") }  } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="d-block">Movimiento: {this.state.movimiento_descripcion}</label>
                                    <label className="d-block">Naturaleza: {this.state.naturaleza}</label>
                                </div>
                                </div>

                            </div>
                                          
                         </div>
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Referencia</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="referencia"
                                    maxLength={25}
                                    value={compra.referencia} 
                                    onChange={this.handleInputChange}  />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Concepto</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="concepto"
                                    maxLength={75}
                                    value={compra.concepto} 
                                    onChange={this.handleInputChange}  />
                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className>Fecha:</label>
                                <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha"
                                    value={compra.fecha || ''}
                                    onChange={this.handleInputChange}
                                   
                                />
                            </div>
                        </div>
                        </div>
                         <div className="row form_cliente">
                         <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Proveedor:</label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="proveedor_codigo"
                                            value={this.state.proveedor_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                            disabled={!editar}
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(14,"Proveedores","proveedor_id") } } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.proveedor_descripcion}</label>
                                </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Factura Compra:</label>
                                            <Input
                                            placeholder=""
                                            name="factura_codigo"
                                            value={this.state.factura_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                             className="input_button"
                                             disabled={!editar}
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(27,"Almacenes","factura_id") } } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.factura_descripcion}</label>
                                </div>
                                </div>

                            </div>               
                         </div>
                        <div className="row form_cliente">
                         <div className="col-md-4">
                            <div className="row">
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Forma de Pago:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="forma_pago_id"
                                        options={this.state.formas}
                                        value={parseInt(compra.forma_pago_id) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'forma_pago_id') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-8">
                            <FormGroup>
                                <Label>Anexo
                                </Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="anexo"
                                    value={compra.anexo}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                            </div>               
                         </div>
                         <div className="col-md-8 ">
                            <div className="row">
                               <div className="col-md-1">
                                 <div className="row">
                                 </div>               
                               </div>
                               <div className="col-md-7 mt-5">
                                  <div className="row">
                                  <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Subtotal Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.subtotal_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Impuestos Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.impuesto_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Original: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_original}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Proveedor: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_proveedor}</Label></h5>
                                        </FormGroup>
                                    </div>
                                  </div>               
                               </div>
                               <div className="col-md-4">
                                  <div className="row">
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <Label>Cantidad</Label>
                                                <Input
                                                placeholder=""
                                                type="number"
                                                name="cantidad"
                                                value={compra.cantidad} 
                                                onChange={this.handleInputChange} 
                                                readOnly 
                                                 />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <Label>+Impuestos</Label>
                                                <Input
                                                placeholder=""
                                                type="number"
                                                name="impuestos"
                                                value={compra.impuestos} 
                                                onChange={this.handleInputChange} 
                                                readOnly 
                                                 />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <Label>Total</Label>
                                                <Input
                                                placeholder=""
                                                type="number"
                                                name="total"
                                                value={compra.total} 
                                                onChange={this.handleInputChange}
                                                 />
                                        </FormGroup>
                                    </div>
                                  </div>               
                               </div> 
                            </div>               
                         </div>                                          
                        </div>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Nota</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="comentario"
                                      value={compra.comentario} 
                                      maxLength={350}
                                      onChange={ this.handleInputChange}
                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>             
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.movimientocaproveedores.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                { this.state.modal&&
                 <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    filtro={1}
                    agregar={this.toggle_modal_registro}
                    proveedor_id={this.state.compra.proveedor_id}
                />
                }

                {
                   this.state.modal_registro==14&& 
                   <Proveedor 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                
                 
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        movimientocaproveedores : state.movimientocaproveedores,
         notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(EmbarqueModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscaproveedores/Modal.js